import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Form, InputNumber } from 'antd';

import { isRequiredField } from '../../../utilz';
import { routeFileSelector } from '../../../utilz/i18n';

const isAllowedInputKey = (e, allowNegative = false) => {
  const allowedControlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
  const isDigit = /^[0-9]$/.test(e.key);
  const isDot = e.key === '.';
  const isMinus = e.key === '-' && allowNegative;

  return isDigit || isDot || isMinus || allowedControlKeys.includes(e.key);
};

const FormInputNumber = ({
  placeholder = false,
  label,
  editMode = false,
  forFilter = false,
  margin = 'mb-15',
  singleLineMode = false,
  name = `testFiled-${Math.random()}`,
  rules = [],
  colon = false,
  inverMode = false,
  disabled,
  onBlur,
  className = '',
  inputType = 'text',
  onChange = false,
  defaultValue,
  readOnly = false,
  minValue = 0,
  precision,
  allowNegative = false,
  tabIndex,
  validateTrigger,
}) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <Form.Item
      className={`form-number-input-container ${inverMode ? 'invert-mode' : ''} ${margin} ${
        singleLineMode ? 'single-line-mode' : ''
      } form-input-container ${!editMode ? 'edit-mode-off' : ''} ${className}`}
      name={name}
      rules={rules}
      label={
        <>
          {label}
          {rules.length > 0 && isRequiredField(rules) && <span className="required">*</span>}
        </>
      }
      labelCol={10}
      colon={colon}
      validateTrigger={validateTrigger}
    >
      <InputNumber
        disabled={disabled}
        readOnly={readOnly ? readOnly : !editMode}
        placeholder={editMode ? (placeholder ? placeholder : `${t('translation:default.fields.enter')} ${label}`) : ''}
        className={`${forFilter ? 'filter-input' : 'form-input form-input-number'}`}
        {...(onBlur ? { onBlur } : {})}
        type={inputType}
        {...(onChange ? { onChange } : {})}
        defaultValue={defaultValue}
        {...(allowNegative ? {} : { min: minValue })}
        id={name}
        decimalSeparator="."
        precision={precision}
        {...(tabIndex ? { tabIndex } : {})}
        onKeyDown={(e) => {
          if (!isAllowedInputKey(e, allowNegative)) {
            e.preventDefault();
          }
        }}
      />
    </Form.Item>
  );
};

export default FormInputNumber;
